import styled from "styled-components";

export const MultiFilterContainer = styled.div`
    display: grid;
    padding: 8px 16px;
    column-gap: 16px;
    row-gap: 16px;
    grid-template-columns: repeat(auto-fill, 310px);
    width: 100%;
`